<template>
  <div class="userWrap">
    <div class="header">
      <div class="logoWrap">
        <img class="logo" src="/img/logoBg.png" alt="">
        <p class="logoName">建筑应用创新大奖</p>
        <p class="logoNameEn">ARCHITECTURAL APPLICATION INNOVATION AWARD</p>
      </div>
      <div class="pageName">
        <span class="bigName">{{pageName}}系统认证平台</span>
        <span class="nameNote">请您登录</span>
        <router-link class="website" to="/award/index" target="_blank">大奖官网</router-link>
      </div>
    </div>
    <div class="bgWrap">
      <div class="contentBox">
        <div class="subPage">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      pageName: '官网'
    }
  }
}
</script>

<style lang="scss" scoped>
.userWrap{
  min-width: 1200px;
  .bgWrap{
    background: url(/img/bg.jpg) no-repeat;
    background-size: cover;
    overflow: auto;
    padding: 50px 80px;
    .contentBox{
      width: 1000px;
      margin: auto;
      text-align: right;
      .subPage{
        text-align: left;
        display: inline-block;
        width: 442px;
      }
    }
  }
}
</style>